import { api, endpoint } from '@/plugins/axios'

// stream crud api's

const getStreams = async params => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(endpoint.STREAM, { params: { institutionId, ...params } })

  return res
}

const getStream = async streamId => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(`${endpoint.STREAM}/${streamId}`, { params: { institutionId } })

  return res
}

const createStream = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.post(endpoint.STREAM, { institutionId, ...payload })

  return res
}

const updateStream = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.put(endpoint.STREAM, { institutionId, ...payload })

  return res
}

const deactivateStream = async streamId => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.delete(`${endpoint.STREAM}/${streamId}`, { params: { institutionId } })

  return res
}

// student subject enrollment api's

const getEnrollmentForClassSection = async params => {
  const res = await api.get(endpoint.STUDENT_SUBJECT_ENROLLMENT, { params })

  return res
}

const getEnrollmentForStudent = async params => {
  const { studentId, ...rest } = params
  const res = await api.get(`${endpoint.STUDENT_SUBJECT_ENROLLMENT}/student/${studentId}`, { params: rest })

  return res
}

const assignStream = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.put(endpoint.STUDENT_SUBJECT_ENROLLMENT, { institutionId, ...payload })

  return res
}

const bulkAssignStream = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.put(`${endpoint.STUDENT_SUBJECT_ENROLLMENT}/bulk`, {
    institutionId,
    ...payload,
  })

  return res
}

export default {
  getStreams,
  getStream,
  createStream,
  updateStream,
  deactivateStream,
  getEnrollmentForClassSection,
  getEnrollmentForStudent,
  assignStream,
  bulkAssignStream,
}
